import React from 'react';
import { Button } from 'react-materialize';

// const Heading = props => (
// 	<div className='heading-container pilotly-gradient'>
// 		<h2 className='heading-title'>{props.title}</h2>
// 	</div>
// );

export const Messages = (props) => {
	const messageKeys = Object.keys(props.messages);

	if (messageKeys.length === 0) {
		return null;
	}

	return (
		<div className="card green lighten-5 contact-us-messages">
			<div className="card-content green-text">
				{messageKeys.map(messageKey => {
					return <p key={messageKey} className='contact-us-message-text'>{props.messages[messageKey]}</p>;
				})}
			</div>
			{props.onClose ?
				<Button type="button" className="green-text" data-dismiss="alert" onClick={props.onClose}>
					<span>×</span>
				</Button>
				: null
			}
		</div>
	);
};

export const Errors = (props) => {
	const errorKeys = Object.keys(props.errors);

	if (errorKeys.length === 0) {
		return null;
	}

	return (
		<div className="card red lighten-5 contact-us-errors">
			<div className="card-content red-text">
				{errorKeys.map(errorKey => {
					return <p key={errorKey} className='contact-us-error-text'>{props.errors[errorKey]}</p>;
				})}
			</div>
			{props.onClose ?
				<Button type="button" className="red-text" data-dismiss="alert" onClick={props.onClose}>
					<span>×</span>
				</Button>
				: null
			}
		</div>
	);
};




// WEBPACK FOOTER //
// ./src/components/global/Messages.js